var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('h3',[_vm._v("Stock price for subscribed companies")]),_c('stock-chart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }